import { Select, type SelectProps } from '@aigc/antd';
import type { SafeAny } from '@aigc/types';

export const AspectRatioSelect = (props: SelectProps<string>) => {
  return (
    <Select
      {...props}
      onChange={props.onChange as SafeAny}
      options={[
        {
          label: '16:9',
          value: '16:9',
        },
        {
          label: '9:16',
          value: '9:16',
        },
      ]}
    ></Select>
  );
};
